import { newsApi } from './api';

export const FactoryCompanyService = newsApi.injectEndpoints({
    endpoints: (build) => ({
        getSelectFactoryCompany: build.query({
            query: () => ({
                url: `select/factoring`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
            keepUnusedDataFor: 0, // 🚀 no caching
        }),
        getFactoryCompany: build.query({
            query: ({ pagination }) => ({
                url: `factoring-companies${pagination && pagination}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        addFactoryCompany: build.mutation({
            query: (form) => ({
                url: `factoring-companies/store`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        markAsDefault: build.mutation({
            query: (id) => ({
                url: `factoring-companies/make-default/${id}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        editFactoryCompany: build.mutation({
            query: ({ id, newForm }) => ({
                url: `factoring-companies/update/${id}`,
                method: 'PUT',
                body: newForm,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        removeFactoryCompany: build.mutation({
            query: (id) => ({
                url: `factoring-companies/delete/${id}`,
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetSelectFactoryCompanyQuery,
    useGetFactoryCompanyQuery,
    useMarkAsDefaultMutation,
    useAddFactoryCompanyMutation,
    useEditFactoryCompanyMutation,
    useRemoveFactoryCompanyMutation,
} = FactoryCompanyService